export default __webpack_public_path__ + "static/media/not-found.d199a503.png";